import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

Vue.config.productionTip = false;
// vant
import Vant from "vant";
import "vant/lib/index.css";
import * as echarts from "echarts";
Vue.prototype.$echarts = echarts;
// 过滤器
import filters from "@/util/filters.js";
Object.keys(filters).forEach((key) => Vue.filter(key, filters[key]));

Vue.use(Vant);
// 转盘
import VueLuckyCanvas from "@lucky-canvas/vue";
Vue.use(VueLuckyCanvas);
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
